// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/8ad5f3b14e17c8814543.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"efe087648b697056fee8","180":"c56b3952e4f25b689315","245":"1067ee1592d2255b76f9","246":"b952d810bf49f3ab5bc9","247":"54208961761da57922b6"}[chunkId] + ".chunk.js";
};